// @flow

export const SET_CURRENT_VERSION = "version/SET_CURRENT_VERSION";
export const SHOW_UPDATE_AVAILABLE = "version/SHOW_UPDATE_AVAILABLE";
export const HIDE_UPDATE_AVAILABLE = "version/HIDE_UPDATE_AVAILABLE";

export const setCurrentVersion = (version: string) => ({
    type: SET_CURRENT_VERSION,
    payload: version,
});

export const showUpdateAvailable = () => ({
    type: SHOW_UPDATE_AVAILABLE,
});

export const hideUpdateAvailable = () => ({
    type: HIDE_UPDATE_AVAILABLE,
});